<div class="mb-5">
	<app-daily-utilization-chart
		[chart]="chart"
		[showUsageValue]="true"
		[maxValue]="800"
		[chartType]="chartType"
		[hasTruckTypeFilter]="true"
		[devicesType]="devicesType"
		[title]="'utilization.daily_ah_fleet_utilization_title' | translate"
		[tooltipText]="'daily_ahr_fleet_utilization' | translate"
		[vAxisTitle]="'site.number_of_trucks' | translate"
		[userParentFilters]="true"
		[fromDate]="fromDate"
		[toDate]="toDate"
		[selectedTruckType]="selectedTruckType"
		[selectedTruckManufacturer]="selectedTruckManufacturer"
		(prepareParentFiltersOptions)="onPrepareParentFiltersOptions($event)"
	></app-daily-utilization-chart>
</div>
